export default function (Vue) {
  // 深复制
  Vue.prototype.clone = function (obj) {
    if (typeof obj !== 'object') { return obj }
    if (JSON) {
      const str = JSON.stringify(obj)
      return JSON.parse(str)
    }
  }

  /**
   * 获取本机年月日
   * format: yyyy-MM-dd hh:mm:ss && yyyy-MM-dd
   */
  Vue.prototype.formatTimeStamp = function (format) {
    var formatTime
    format = format || 'yyyy-MM-dd hh:mm:ss'
    var date = new Date()
    var o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds() // 秒
    }
    if (/(y+)/.test(format)) {
      formatTime = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    } else {
      formatTime = format
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(formatTime)) {
        formatTime = formatTime.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k])
          .length)))
      }
    }
    return formatTime
  }

  /**
   * 时间戳转为普通日期格式，字符串yy-mm-dd hh:mm也可以转
   * date: 时间戳
   * week：是否要显示星期几
   */
  Vue.prototype.convertLocalTime = function (date, week) {
    if (date) {
      date = new Date(date)
      var str = ''
      var YY = date.getFullYear() + '-'
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
      var day = date.getDay()
      str = YY + MM + DD + ' ' + hh + mm
      if (week) {
        str += (' ' + { 0: '星期日', 1: '星期一', 2: '星期二', 3: '星期三', 4: '星期四', 5: '星期五', 6: '星期六' }[day])
      }
      return str
    }
    return ''
  }

  /**
   * 时间转时间戳
   * date: 字符串日期 yyyy-MM-dd hh:mm:ss || yyyy-MM-dd || yyyy-M-d
   */
  Vue.prototype.convertTimeStamp = function (date) {
    if (date && typeof date === 'string' && date.length >= 8) {
      return new Date(date.replace(/-/g, '/')).getTime()
    }
    return ''
  }

  /**
   * 全局只播放一次音频（主屏播放后副屏不再重复）
   * @param {string} src 音频文件路径
   * @param {number} delay 延迟毫秒数
   */
  Vue.prototype._audioElements = Vue.prototype._audioElements || []
  Vue.prototype.playOnceAudio = function (src, delay = 200) {
    const key = 'audio_played_' + encodeURIComponent(src)
    if (localStorage.getItem(key) === '1') return
    localStorage.setItem(key, '1')
    setTimeout(() => {
      const audio = document.createElement('audio')
      audio.src = src
      audio.autoplay = true
      audio.style.display = 'none'
      document.body.appendChild(audio)
      // 跟踪 audio 元素，供页面切换时销毁
      Vue.prototype._audioElements.push(audio)
    }, delay)
  }

  /**
   * 停止并销毁所有正在播放的音频
   */
  Vue.prototype.stopAllAudio = function () {
    const audios = Vue.prototype._audioElements || []
    audios.forEach(a => {
      try { a.pause() } catch (e) { /* ignore */ }
      try { a.src = '' } catch (e) { /* ignore */ }
      try { a.remove() } catch (e) { /* ignore */ }
    })
    Vue.prototype._audioElements = []
  }

  // 秒换算 分:秒
  Vue.prototype.s_to_hs = function (s) {
    // 计算分钟：将秒数除以60，然后下舍入，得到分钟数
    var h
    h = Math.floor(s / 60)
    // 计算秒：取得秒%60的余数，得到秒数
    s = s % 60
    // 将变量转换为字符串
    h += ''
    s += ''
    // 如果只有一位数，前面增加一个0
    h = (h.length === 1) ? '0' + h : h
    s = (s.length === 1) ? '0' + s : s
    return h + ':' + s
  }

  // 时间戳转换时分秒
  Vue.prototype.fmtDHS = function (num) {
    if (isNaN(num)) { return }
    var h, m, s, mm, ss
    num = num < 0 ? 0 : num
    h = Math.floor(num / (60 * 60 * 1000))
    mm = num - (h * (60 * 60 * 1000))
    m = Math.floor(mm / (60 * 1000))
    ss = mm - (m * 60 * 1000)
    s = Math.floor(ss / (1000))
    h += ''
    m += ''
    s += ''
    h = (h.length === 1) ? '0' + h : h
    m = (m.length === 1) ? '0' + m : m
    s = (s.length === 1) ? '0' + s : s
    return h + ':' + m + ':' + s
  }

  // 生成随机字符数字, n=长度（默认5）
  Vue.prototype.generateMixed = function (n) {
    var res = ''
    n = Math.abs(Number(n) || 5)
    for (var i = 0; i < n; i++) {
      res += Math.floor(Math.random() * 10)
    }
    return res
  }

  // 随机生成字符串，n=长度（默认10）
  Vue.prototype.getRandomString = function (n) {
    const charStr = 'abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789'
    const max = charStr.length - 1
    let str = ''
    n = n || 10
    // 循环生成字符串
    for (var i = 0; i < n; i++) {
      const s = Math.round(Math.random() * max)
      str += charStr.substring(s, s + 1)
    }
    return str
  }

  // 判断两个对象是否相等，例 a: {a: 1}，b: {a: 2} 不对等
  Vue.prototype.isObjectEqual = function (a, b) {
    var aProps = Object.getOwnPropertyNames(a)
    var bProps = Object.getOwnPropertyNames(b)
    var propName; var i = 0
    if (aProps.length !== bProps.length) { return }
    for (i; i < aProps.length; i++) {
      propName = aProps[i]
      if (a[propName] !== b[propName]) { return }
    }
    return true
  }

  // 求指定日期添加天数后的提起，例 dateStr：2024-12-12，dayCount：加的天数
  Vue.prototype.dateAddDays = function (dateStr, dayCount) {
    if (!dateStr) { return }
    if (!dayCount) { return dateStr }
    if (dateStr.length === 8) {
      const y = dateStr.substr(0, 4)
      const m = dateStr.substr(4, 2)
      const d = dateStr.substr(6, 2)
      dateStr = `${y}-${m}-${d}`
    }
    var tempDate = new Date(dateStr.replace(/-/g, '/'))// 把日期字符串转换成日期格式
    var resultDate = new Date((tempDate / 1000 + (86400 * dayCount)) * 1000)// 增加n天后的日期
    var MM = (resultDate.getMonth() + 1 < 10 ? '0' + (resultDate.getMonth() + 1) : resultDate.getMonth() + 1)
    var DD = (resultDate.getDate() < 10 ? '0' + (resultDate.getDate()) : resultDate.getDate())
    return resultDate.getFullYear() + '-' + MM + '-' + DD
  }


  // 生成范围数字，m：最小范围，n：最大范围
  Vue.prototype.rangeNum = function (m, n) {
    return Math.ceil(Math.random() * (n - m + 1) + m - 1)
  }

  // 获取两数百分比，num：为基准，denominator：求与num百分比的数字
  Vue.prototype.percentage = function (num, denominator) {
    if (denominator === 0 || isNaN(num) || isNaN(denominator)) {
      return 0
    }
    return ((num / denominator) * 100).toFixed(2)
  }

  // 数字取2留整，不四舍五入，保留两位小数
  Vue.prototype.KeepWwholeNum = function (num) {
    if (typeof num === 'number') {
      return Number(num.toFixed(2))
    }
    return num
  }

  // 数字转汉字
  Vue.prototype.numberToChinese = function (num) {
    const units = ["", "十", "百", "千", "万", "十万", "百万", "千万", "亿"]
    const numerals = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"]

    if (num === 0) return "零"

    let result = ""
    let unitIndex = 0
    while (num > 0) {
      const currentDigit = num % 10
      if (currentDigit !== 0) {
        result = numerals[currentDigit] + units[unitIndex] + result
      } else if (result[0] !== '零') {
        result = '零' + result
      }
      num = Math.floor(num / 10)
      unitIndex++
    }
    if (result == '一十零') {
      return '十'
    }
    return result.replace(/零+/g, "零").replace(/零$/, "")
  }

}
